import React from "react";

export default function Footer() {
  return (
    <div style={{bottom:"5px",paddingTop:'50px',fontSize:'12px'}}>
      Developed with ❤ by{" "}
      <a tarhet="_blank" href="https://github.com/mdb571">
        @mdb571
      </a>{"  & "}
      <a tarhet="_blank" href="https://github.com/bmnidhin">
        @bmnidhin
      </a>
    </div>
  );
}
